import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ number, title, testId }) => (
  <Reveal className="mb-10 sm:mb-14">
    <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#0D9488] mb-3">
      {number}/
    </p>
    <h2
      data-testid={testId}
      className="text-2xl sm:text-3xl lg:text-4xl font-display font-semibold text-[#0D3B3E] tracking-tight"
    >
      {title}
    </h2>
    <div className="mt-5 h-px w-full bg-[#0D3B3E]/10" />
  </Reveal>
);
